import {
  Table2, Columns3, Wrench, GitCompareArrows, FileCode2, RefreshCw,
  Download, FileUp, Pencil, Copy, Eraser, Trash2,
} from 'lucide-react';
import type { ContextMenuItem } from '@/components/shared/ContextMenu';

export interface TableActionDeps {
  onOpenTable: () => void;
  onViewStructure: () => void;
  onModifyTable: () => void;
  onCompareWith: () => void;
  onNewSelectQuery: () => void;
  onReload: () => void;
  onBackup: () => void;
  onImport: () => void;
  onRename: () => void;
  onCopyTableName: () => void;
  onCopySelectQuery: () => void;
  onTruncate: () => void;
  onDrop: () => void;
}

/**
 * Build the canonical action list for a table node. Opens-the-table is the
 * primary action, since that's what users want ~90% of the time. Rows under
 * it mirror the right-click context menu: Operations, Data, Manage, Danger.
 */
export function buildTableActions(
  schema: string,
  table: string,
  deps: TableActionDeps,
  rowEstimate?: number,
): ContextMenuItem[] {
  return [
    {
      label: 'Open Table',
      icon: Table2,
      onClick: deps.onOpenTable,
      primary: true,
      sublabel: rowEstimate != null
        ? `${schema}.${table} · ~${rowEstimate.toLocaleString()} rows`
        : `${schema}.${table}`,
    },

    { label: '', separator: true, sectionTitle: 'Operations' },
    { label: 'View Structure', icon: Columns3, onClick: deps.onViewStructure },
    { label: 'Modify Table…', icon: Wrench, onClick: deps.onModifyTable },
    { label: 'Compare With…', icon: GitCompareArrows, onClick: deps.onCompareWith },
    { label: 'New Query (SELECT *)', icon: FileCode2, onClick: deps.onNewSelectQuery },
    { label: 'Reload', icon: RefreshCw, onClick: deps.onReload },

    { label: '', separator: true, sectionTitle: 'Data' },
    { label: 'Backup Table…', icon: Download, onClick: deps.onBackup },
    { label: 'Import Data…', icon: FileUp, onClick: deps.onImport },

    { label: '', separator: true, sectionTitle: 'Manage' },
    { label: 'Rename Table…', icon: Pencil, onClick: deps.onRename },
    { label: 'Copy Table Name', icon: Copy, onClick: deps.onCopyTableName },
    { label: 'Copy SELECT Query', icon: Copy, onClick: deps.onCopySelectQuery },

    { label: '', separator: true, sectionTitle: 'Danger Zone' },
    { label: 'Truncate Table…', icon: Eraser, danger: true, onClick: deps.onTruncate },
    { label: 'Drop Table…', icon: Trash2, danger: true, onClick: deps.onDrop },
  ];
}
